const SET_WINDOW_WIDTH = (state, payload) => {
  state.windowWidth = payload;
};

const SET_SIDEBAR_STATUS = (state, payload) => {
  state.sidebarStatus = payload;
};
export default {
  SET_WINDOW_WIDTH,
  SET_SIDEBAR_STATUS
};
